import React, { PropTypes } from 'react';
import RenderField from '../../../FormTemplate/InputControl';
import { Field } from 'redux-form';
import { Button, Table } from 'react-bootstrap';
import alert from 'alertify.js';
import axios from './../../../../constants/axios';
import className from 'classnames';
import './RenderList.less';

class RenderInventoryCounterList extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         itemLists: [],
      };
   }

   barcodeInputOnEnter = (e) => {
      if (e.keyCode === 13 && e.target.value) {
         // search for barcode. If found, push items
         return axios.get('/inventorySales/inventorySaleItems/searchByBarcode/' + e.target.value)
            .then((res) => {
               if (res.status === 200) {
                  // Ok Item found. Push it;
                  if (this.props.items) {
                     const findIndex = this.props.items.findIndex((itm) => itm.item_id === res.data.id);
                     if (findIndex > -1) {
                        const oldUnit = this.props.items[findIndex].unit;
                        this.props.fields.remove(findIndex);
                        this.addItemOnList(res.data, oldUnit + 1);
                     } else {
                        this.addItemOnList(res.data);
                     }
                  } else {
                     this.addItemOnList(res.data);
                  }
               }
               this.clearBarcodeField();
            })
            .catch((err) => {
               if (err && err.response && err.response.status === 422) {
                  alert.error(err.response.data);
               }
               this.clearBarcodeField();
            });
      }
   };

   clearBarcodeField = () => {
      this.refs.barcode.value = '';
      this.refs.barcode.focus();
   };

   addItemOnList = (item, unit) => {
      this.props.fields.push({
         item_id: item.id,
         name: item.name,
         price: item.price,
         unit: unit || 1,
         net_weight: item.net_weight,
         unit_discount: item.discount
      });
   };

   searchProductByName = (e) => {
      // search for barcode. If found, push items
      return axios.get('/inventorySales/inventorySaleItems/searchByName/' + e.target.value)
         .then((res) => {
            this.setState({
               itemLists: res.data,
            });
         })
         .catch(() => {
         });
   };

   clickOnItem = (item) => {
      this.addItemOnList(item);
      this.refs.nameSearch.value = '';
      this.setState({
         itemLists: [],
      });
   };


   render() {
      const { fields, items } = this.props;
      const { itemLists } = this.state;

      return (
         <div className="RenderInventoryCounterList" >
            <Table >
               <thead >
               <tr >
                  <th >SL.</th >
                  <th >Item Id</th >
                  <th >ItemName</th >
                  <th >Unit</th >
                  <th >Price</th >
                  <th >Unit Discount</th >
                  <th >Dis P%</th >
                  <th >Total</th >
                  <th >##</th >
               </tr >
               </thead >
               <tbody >
               {fields.map((item, index) =>
                  <tr key={index} >
                     <td >
                        {index + 1}
                     </td >
                     <td className="col-md-1" >
                        <Field
                           disabled
                           name={`${item}.item_id`}
                           type="number"
                           component={RenderField} />
                        <Field
                           name={`${item}.net_weight`}
                           type="hidden"
                           component="input" />
                     </td >
                     <td className="col-md-7" >
                        {/*<Field*/}
                        {/*name={`${item}.name`}*/}
                        {/*type="text"*/}
                        {/*component={RenderField} />*/}
                        {items && items.length > 0 && items[index] && items[index].name && items[index].name}
                     </td >
                     <td className="col-md-1" >
                        <Field
                           name={`${item}.unit`}
                           type="number"
                           component={RenderField} />
                     </td >
                     <td className="col-md-1" >
                        <Field
                           name={`${item}.price`}
                           type="number"
                           component={RenderField} />
                     </td >
                     <td className="col-md-1" >
                        <Field
                           name={`${item}.unit_discount`}
                           type="number"
                           component={RenderField} />
                     </td >
                     <td style={{ border: '1px solid black' }} >
                        {items && items.length > 0 && items[index] && items[index].discount_percentage}
                     </td >
                     <td className="col-md-1" >
                        {items && items.length > 0 && items[index] && items[index].total && items[index].total}
                     </td >
                     <td >
                        <Button onClick={() => fields.remove(index)} >x</Button >
                     </td >
                  </tr >
               )}
               </tbody >
            </Table >
            <span >
                           Barcode: <input ref="barcode" placeholder="Scan Barcode" type="text" name="barcode"
                                           onKeyDown={(e) => this.barcodeInputOnEnter(e)} />
            </span >
            <span >
                           Name Search: <input ref="nameSearch" placeholder="Search Products" type="text"
                                               name="nameSearch"
                                               onKeyDown={(e) => this.searchProductByName(e)} />
               {itemLists &&
               <ul className="renderInventoryCounterListUl" >
                  {itemLists.map((item) => <li key={item.id} onClick={() => this.clickOnItem(item)}
                                               className={className({
                                                  renderInventoryCounterListItem: true,
                                                  outOfStock: item.unit_on_hand <= 0,
                                               })} >{item.name}</li >)}
               </ul >
               }
            </span >
         </div >
      );
   }
}

RenderInventoryCounterList.propTypes = {
   fields: PropTypes.object,
   items: PropTypes.array
};

export default RenderInventoryCounterList;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/FormHelper/RenderItemList.js
 **/